module.exports = __webpack_public_path__ + "img/network-analyzer-lg.07ce172c.svg";